import { useT } from "@/i18n";
import { useUiSounds } from "@/lib/audio";
import { LogOut, X } from "lucide-react";

export default function ExitDialog({ open, onClose }) {
    const t = useT();
    const sfx = useUiSounds();

    if (!open) return null;

    const doExit = () => {
        sfx.click();
        try {
            window.close();
        } catch (e) {}
        // Fallback for browsers that block window.close
        window.location.reload();
    };

    return (
        <div
            data-testid="exit-dialog"
            className="fixed inset-0 z-50 flex items-center justify-center bg-black/70 backdrop-blur-md axis-fade-in"
            onClick={onClose}
        >
            <div
                className="axis-glass axis-cut max-w-md w-[92%] p-8 border-red-500/40"
                onClick={(e) => e.stopPropagation()}
            >
                <div className="flex items-center gap-3 mb-4">
                    <div className="p-2 border border-red-500/60 axis-cut-sm">
                        <LogOut size={20} className="text-red-400" />
                    </div>
                    <div>
                        <div className="axis-mono text-[10px] tracking-[0.4em] text-red-400/80">
                            SYSTEM
                        </div>
                        <div className="axis-heading text-xl text-white tracking-widest">
                            {t("exit.title")}
                        </div>
                    </div>
                </div>
                <div className="axis-mono text-sm text-white/70 leading-relaxed">
                    {t("exit.message")}
                </div>
                <div className="mt-6 flex justify-end gap-3">
                    <button
                        data-testid="exit-cancel"
                        onClick={() => { sfx.close(); onClose(); }}
                        className="axis-btn axis-btn-ghost axis-cut-sm px-5 py-2 text-xs flex items-center gap-2"
                    >
                        <X size={13} /> {t("common.cancel")}
                    </button>
                    <button
                        data-testid="exit-confirm"
                        onClick={doExit}
                        className="axis-btn axis-cut-sm px-5 py-2 text-xs border border-red-500 bg-red-500/15 text-red-300 hover:bg-red-500/30 hover:text-white transition flex items-center gap-2"
                    >
                        <LogOut size={13} /> {t("exit.confirm")}
                    </button>
                </div>
            </div>
        </div>
    );
}
